import React from 'react';
import { Link } from 'react-router-dom';
import { parseMarkdownToReact } from '../../utils/markdownRenderer';

const CommentContent = ({ content, mentions = [] }) => {
  // Function to extract YouTube video ID from various URL formats
  const extractYouTubeId = (url) => {
    const patterns = [
      /(?:youtube\.com\/watch\?v=|youtu\.be\/|youtube\.com\/embed\/)([^&\s]+)/,
      /youtube\.com\/watch\?.*v=([^&\s]+)/
    ];
    
    for (const pattern of patterns) {
      const match = url.match(pattern);
      if (match) {
        // Remove timestamp parameter if present
        return match[1].split('&')[0];
      }
    }
    return null;
  };

  // Function to extract timestamp from YouTube URL
  const extractTimestamp = (url) => {
    const timestampMatch = url.match(/[?&]t=(\d+)/);
    if (timestampMatch) {
      return timestampMatch[1];
    }
    return null;
  };

  // Process content for YouTube embeds and markdown
  const renderContent = (text) => {
    if (!text) return null;

    const elements = [];
    let keyIndex = 0;

    // Split content by lines to check for YouTube URLs
    const lines = text.split('\n');
    
    lines.forEach((line, lineIndex) => {
      // Check if line contains a standalone YouTube URL
      const youtubeUrlPattern = /^(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/watch\?v=|youtu\.be\/|youtube\.com\/embed\/)([\S]+)$/;
      const match = line.trim().match(youtubeUrlPattern);
      
      if (match) {
        // This line is just a YouTube URL - embed it
        const videoId = extractYouTubeId(line.trim());
        const timestamp = extractTimestamp(line.trim());
        
        if (videoId) {
          const embedUrl = `https://www.youtube.com/embed/${videoId}${timestamp ? `?start=${timestamp}` : ''}`;
          elements.push(
            <div key={`youtube-${keyIndex++}`} className="youtube-embed-container">
              <iframe
                src={embedUrl}
                title="YouTube video player"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                className="youtube-embed"
              />
            </div>
          );
        }
      } else {
        // Process line with markdown
        const lineElements = parseMarkdownToReact(line, {
          renderMentions: true,
          renderLinks: true,
          renderBold: true,
          renderItalic: true,
          renderStrike: true,
          renderLineBreaks: false, // We handle line breaks manually
          mentionedUsers: mentions
        });
        
        if (lineElements) {
          elements.push(
            <span key={`line-${keyIndex++}`}>
              {lineElements}
            </span>
          );
        }
      }
      
      // Add line break if not last line
      if (lineIndex < lines.length - 1) {
        elements.push(<br key={`br-${keyIndex++}`} />);
      }
    });

    return elements.length > 0 ? elements : null;
  };

  return (
    <div className="comment-content-wrapper">
      {renderContent(content)}
    </div>
  );
};

export default CommentContent;